module.exports = __webpack_public_path__ + "img/astral-txt_24.94de119b.svg";